import React from 'react';
import classnames from 'classnames';

import styles from './modal-content.module.css';

type ModalContentContainerProps = {
    children: React.ReactNode;
    containerClassName?: string;
};

const ModalContentContainer = ({ children, containerClassName }: ModalContentContainerProps) => {
    return <div className={classnames(styles.modalBody, containerClassName)}>{children}</div>;
};

export default ModalContentContainer;
